export default __webpack_public_path__ + "static/image17-dbd5f689c300f493ee8ebee354ecb837.gif";